module.exports = __webpack_public_path__ + "img/span-icon1.86905fbe.png";